<div *ngIf="device != null">
  <div class="prop">
    {{ "COLUMNS.MAC" | translate }}: {{ deviceIdentifier.Name }}
  </div>
  <div class="prop">
    {{ "COLUMNS.BATTERY" | translate }}: {{ device.BatteryLevel }}%
  </div>
  <div *ngIf="device.Temperature" class="prop">
    {{ "COLUMNS.TEMPERATURE" | translate }}:
    {{ device.Temperature }}
  </div>
  <div *ngIf="device.TemperatureAdjustment" class="prop">
    {{ "COLUMNS.TEMPERATURE_CALIBRATION" | translate }}:
    {{ device.TemperatureAdjustment }}
  </div>
  <div *ngIf="device.LastTempAdjustCertificate" class="prop">
    {{ "COLUMNS.CALIBRATION_CERTIFICATE" | translate }}:
    {{ device.LastTempAdjustCertificate }}
  </div>
  <div class="prop" *ngIf="device.DateCreated">
    {{ "COLUMNS.DATE_CREATED" | translate }}: {{ device.DateCreated }}
  </div>
  <div class="prop" *ngIf="device.DateUpdated">
    {{ "COLUMNS.DATE_UPDATED" | translate }}: {{ device.DateUpdated }}
  </div>
  <div
    *ngIf="device.ItemId && device.PersonAssociated"
    class="breadcrumb-link"
    (click)="
      navigateTo({
        PanelName: 'asset',
        Params: { Name: device.PersonAssociated, ID: device.ItemId }
      })
    "
  >
    {{ "COLUMNS.ASSOC_ASSET" | translate }}: {{ device.PersonAssociated }}
  </div>
</div>
